export const screenerIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'This is the Screener Results report where you can view student screening assessment results.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade or class.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Screener Results.'
  },
  {
    element: '.screener-report-chart',
    intro: 'See the three risk categories that students are sorted into: High Risk, Some Risk, and Proficient. The WordFlight Screener estimates the student\'s performance on the WordFlight Diagnostic and provides a risk category. See the chart and graphic for the number of students in each of the three risk categories. Some Risk and High Risk students are recommended as excellent candidates for WordFlight. Minimally proficient students may also benefit from using WordFlight.'
  },
  {
    element: '.status-totals-section',
    intro: 'See the number of students who have not started the Screener, have started the Screener, have skipped the Screener, and the total number of students who were enrolled in the Screener.',
  },
  {
    element: 'table.report-table',
    intro: 'See the results for all of the students who have taken the WordFlight Screener. You can see their name, grade, results, date started, and date completed. WordFlight recommends students complete the Screener in a single session.'
  },
  {
    element: '#results-th',
    intro: 'The WordFlight Screener estimates the student\'s performance on the WordFlight Diagnostic, which has a scale of 0 to 600. Screener results are presented in a confidence interval of 60 scale points. See the color of the score to see which risk category the student is in.'
  },
];
